import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface Filter {
    name: string;
    code?: string;
}

export interface IListCurrencyRateRequest extends IBaseRequest {
    id?:          string;
    linkTable?:   string;
    linkName?:    string;
    treeHandle?:  string;
    orderBy?:     string;
    orderByType?: string;
    countOnly?:   string;
    offset?:      string;
    limit?:       string;
    FILTER?:      Filter;
    currency?:    string;
    rateDate?:    string;
}

export class ListCurrencyRateRequest extends BaseRequest implements IListCurrencyRateRequest {
    public id?:          string;
    public linkTable?:   string;
    public linkName?:    string;
    public treeHandle?:  string;
    public orderBy?:     string;
    public orderByType?: string;
    public countOnly?:   string;
    public offset?:      string;
    public limit?:       string;
    public FILTER?:      Filter;
    public currency?:    string;
    public rateDate?:    string;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.id = otherOptions.id;
    this.linkTable = otherOptions.linkTable;
    this.linkName = otherOptions.linkName;
    this.treeHandle = otherOptions.treeHandle;
    this.orderBy = otherOptions.orderBy;
    this.orderByType = otherOptions.orderByType;
    this.countOnly = otherOptions.countOnly;
    this.offset = otherOptions.offset;
    this.limit = otherOptions.limit;
    this.FILTER = otherOptions.FILTER;
    this.currency = otherOptions.currency;
    this.rateDate = otherOptions.rateDate;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.linkTable, 'linkTable');
    parameters += this.makeNode(this.linkName, 'linkName');
    parameters += this.makeNode(this.treeHandle, 'treeHandle');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.orderByType, 'orderByType');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.limit, 'limit');
    if (this.FILTER) {
      parameters += '<FILTER>';
      parameters += this.makeNode(this.FILTER.name, 'name');
      parameters += this.makeNode(this.FILTER.code, 'code');
      parameters += '</FILTER>';
    }    
    parameters += this.makeNode(this.currency, 'currency');
    parameters += this.makeNode(this.rateDate, 'rateDate');

    return super.wrapperXml('ListCurrencyRate', parameters);
  }
}
